import { render, staticRenderFns } from "./SinglePondDetail.vue?vue&type=template&id=0025b8f8&scoped=true"
import script from "./SinglePondDetail.vue?vue&type=script&lang=js"
export * from "./SinglePondDetail.vue?vue&type=script&lang=js"
import style0 from "./SinglePondDetail.vue?vue&type=style&index=0&id=0025b8f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0025b8f8",
  null
  
)

export default component.exports